module.exports = __webpack_public_path__ + "img/cleaner.38649164.svg";